/* */ 
(function(Buffer) {
  'use strict';
  var fs = require('fs'),
      ono = require('ono'),
      Promise = require('../util/promise'),
      url = require('../util/url'),
      debug = require('../util/debug');
  module.exports = {
    order: 100,
    canRead: function isFile(file) {
      return url.isFileSystemPath(file.url);
    },
    read: function readFile(file) {
      return new Promise(function(resolve, reject) {
        var path;
        try {
          path = url.toFileSystemPath(file.url);
        } catch (err) {
          reject(ono.uri(err, 'Malformed URI: %s', file.url));
        }
        debug('Opening file: %s', path);
        try {
          fs.readFile(path, function(err, data) {
            if (err) {
              reject(ono(err, 'Error opening file "%s"', path));
            } else {
              resolve(data);
            }
          });
        } catch (err) {
          reject(ono(err, 'Error opening file "%s"', path));
        }
      });
    }
  };
})(require('buffer').Buffer);
